import { DynamicToolUIPart, getToolName, ToolUIPart } from "ai";

import { TOOL_CALL_DESCRIPTION_FIELD } from "../constants";

export type ToolPart = ToolUIPart | DynamicToolUIPart;

const getLabel = (part: ToolPart): string | undefined => {
  const { input } = part;

  if (typeof input === "object" && input !== null && TOOL_CALL_DESCRIPTION_FIELD in input) {
    const { [TOOL_CALL_DESCRIPTION_FIELD]: description } = input;

    if (typeof description === "string") {
      return description;
    }
  }

  return part.title;
};

export const getToolLabel = (part: ToolPart) => getLabel(part) || getToolName(part);

export const isRunning = (part: ToolPart) =>
  part.state === "input-streaming" ||
  part.state === "input-available" ||
  (part.state === "approval-responded" && part.approval.approved === true);

export const hasDisplayableData = (data: unknown) => {
  if (data === undefined) {
    return false;
  }

  if (data !== null && typeof data === "object") {
    return Object.entries(data).some(
      ([key, value]) => key !== TOOL_CALL_DESCRIPTION_FIELD && value !== undefined
    );
  }

  return true;
};

export const parseOutputData = (data: unknown): unknown => {
  if (typeof data !== "string") {
    return data;
  }

  try {
    return JSON.parse(data);
  } catch {
    return data;
  }
};
